import { render, staticRenderFns } from "./GooglePlayBtn.vue?vue&type=template&id=434eab1a&scoped=true&"
import script from "./GooglePlayBtn.vue?vue&type=script&lang=js&"
export * from "./GooglePlayBtn.vue?vue&type=script&lang=js&"
import style0 from "./GooglePlayBtn.vue?vue&type=style&index=0&id=434eab1a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434eab1a",
  null
  
)

export default component.exports